import api, { rcApi } from './create-api';
import {
  responseFormatter,
  rcApiResponseFormatter,
  readFileAsBuffer,
  getFileExtension,
} from '@utils';
import mime from 'mime-types';

const getVersion = async () => {
  return responseFormatter(
    api.get('/', {
      setAuthHeader: true,
    })
  );
};

const createTicket = async data => {
  return responseFormatter(
    api.post(`azurefeedback`, data, {
      setAuthHeader: true,
    })
  );
};

const getNumbers = (query, accountId, groupId, flag) => {
  const accountQuery = `filter[where][accountId]=${accountId}${
    groupId && !flag ? `&filter[where][carriergroup_id]=${groupId}` : ''
  }`;
  query = query ? query + `&${accountQuery}` : `?${accountQuery}`;

  return responseFormatter(
    api.get(`porting/phonenumbers${query}`, {
      setAuthHeader: true,
    })
  );
};

const uploadFiles = async (data, feedbackId) => {
  return responseFormatter(
    api.post(`azurefeedback/${feedbackId}/attachment/add`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      setAuthHeader: true,
    })
  );
};

const getSites = (
  query,
  accountId,
  shouldFetchCount = false,
  shouldFetchSitesStats = false
) => {
  let builtQuery = query
    ? query + `&filter[where][accountId]=${accountId}`
    : accountId
    ? `?filter[where][accountId]=${accountId}`
    : '';

  builtQuery = shouldFetchCount
    ? `${builtQuery}&filter[includecounts]=true`
    : builtQuery;
  builtQuery = shouldFetchSitesStats
    ? `${builtQuery}&filter[includeSitesStats]=true`
    : builtQuery;

  return responseFormatter(
    api.get(`site${builtQuery}`, {
      setAuthHeader: true,
    })
  );
};

const bulkUpload = (data, section, accountId, overrideDuplicate) => {
  let uploadUrl = '/site/bulkcreate';

  switch (section) {
    case 'profiles':
      uploadUrl = '/site/profile/bulkcreate';
      break;
    case 'siteUsers':
      uploadUrl = '/siteuser/bulkcreate';
      break;
    case 'devices':
      uploadUrl = '/device/bulkcreate';
      break;
    case 'numbers':
      uploadUrl = `/account/${accountId}/phonenumber/bulkcreate`;
      break;
    default:
      uploadUrl = '/site/bulkcreate';
  }

  return responseFormatter(
    api.post(
      uploadUrl,
      { data, accountId: `${accountId}`, overrideDuplicate },
      {
        setAuthHeader: true,
        setTimeout: 120000,
      }
    )
  );
};

const updateThemeType = (userId, type) => {
  return responseFormatter(
    api.patch(`/user/${userId}`, { theme: type }, { setAuthHeader: true })
  );
};

const uploadToGlip = async data => {
  const fileData = await readFileAsBuffer(data.file);
  const fileExt = getFileExtension(data.file.name).toLowerCase();
  return await rcApiResponseFormatter(
    rcApi.post(
      `/glip/files?groupId=${data.chatId}&name=${data.file.name}`,
      fileData,
      {
        headers: {
          'Content-Type': mime.lookup(fileExt),
        },
        setAuthHeader: true,
      }
    )
  );
};

const getMaintenanceSlot = async () => {
  return responseFormatter(
    api.get(`/maintenance`, {
      setAuthHeader: true,
    })
  );
};

const submitRating = (data, isPackageSubmitted = false) => {
  return responseFormatter(
    api.post(`/submit-rating?isPackageSubmitted=${isPackageSubmitted}`, data, {
      setAuthHeader: true,
    })
  );
};

export default {
  bulkUpload,
  getVersion,
  createTicket,
  uploadFiles,
  getSites,
  getNumbers,
  updateThemeType,
  uploadToGlip,
  getMaintenanceSlot,
  submitRating,
};
